import React from 'react';
import { X, Check, Star } from 'lucide-react';
import styles from './UnlockNumberModal.module.css';

const UnlockNumberModal = ({ isOpen, onClose, onUpgrade  , explorePlan}) => {
  if (!isOpen) return null;

  const handleUpgrade = () => {
    onUpgrade();
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div className={styles.backdrop} onClick={onClose} />

      {/* Modal */}
      <div className={styles.modal}>
        {/* Close Button */}
        <button className={styles.closeButton} onClick={onClose}>
          <X size={20} />
        </button>

        {/* Icon */}
        <div className={styles.iconWrapper}>
          <Star size={28} fill="white" color="white" />
        </div>

        {/* Title */}
        <h2 className={styles.title}>
          Unlock Number
          <br />
          Assignment
        </h2>

        {/* Features List */}
        <div className={styles.featuresList}>
          <div className={styles.featureItem}>
            <Check size={18} className={styles.checkIcon} />
            <span className={styles.featureText}>Instant Number Assignment</span>
          </div>
          <div className={styles.featureItem}>
            <Check size={18} className={styles.checkIcon} />
            <span className={styles.featureText}>50 Minutes Monthly Usage</span>
          </div>
          <div className={styles.featureItem}>
            <Check size={18} className={styles.checkIcon} />
            <span className={styles.featureText}>Priority Support</span>
          </div>
        </div>

        {/* Pricing */}
        <div className={styles.pricing}>
          <div className={styles.price}>$5/month</div>
          <div className={styles.billingText}>billed monthly</div>
        </div>

        {/* Upgrade Button */}
        <button className={styles.upgradeButton} onClick={handleUpgrade}>
          Upgrade for $5
        </button>

        {/* Explore Plans Link */}
        {/* <div  className={styles.exploreLink} onClick={explorePlan}>
          Explore All Plans →
        </div> */}
      </div>
    </>
  );
};

export default UnlockNumberModal;